import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['alert']

  connect() {
    setTimeout(this.dismiss.bind(this), 5000)
  }

  dismiss() {
    const alert = this.hasAlertTarget ? this.alertTarget : this.element
    alert.classList.remove('show')
    setTimeout(() => alert.remove(), 150)
  }
}
